// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Uploader-space1-sO2sY {
	margin-bottom: 6px !important;
}

.Uploader-space2-UKJxq {
	margin-bottom: 12px !important;
}

.Uploader-space3-Twa5a {
	margin-bottom: 18px !important;
}

.Uploader-space4-LqZrl {
	margin-bottom: 24px !important;
}

.Uploader-space5-L02z_ {
	margin-bottom: 30px !important;
}

.Uploader-space6-uhfN7 {
	margin-bottom: 36px !important;
}

.Uploader-space7-ick37 {
	margin-bottom: 42px !important;
}

.Uploader-spaceTop8-BfqR0 {
	margin-bottom: 48px !important;
}

.Uploader-spaceTop1-shN8P {
	margin-top: 6px !important;
}

.Uploader-spaceTop2-dqSi3 {
	margin-top: 12px !important;
}

.Uploader-spaceTop3-CxDeV {
	margin-top: 18px !important;
}

.Uploader-spaceTop4-grgmC {
	margin-top: 24px !important;
}

.Uploader-spaceTop5-zbfto {
	margin-top: 30px !important;
}

.Uploader-spaceTop6-sqgrs {
	margin-top: 36px !important;
}

.Uploader-spaceTop7-pJ0n_ {
	margin-top: 42px !important;
}

.Uploader-spaceTop8-BfqR0 {
	margin-top: 48px !important;
}

.Uploader-noMargin-ujLdC {
	margin: 0px !important;
}

.Uploader-padding1-xT8iw {
	padding-bottom: 6px !important;
}

.Uploader-padding2-wAK9l {
	padding-bottom: 12px !important;
}

.Uploader-padding3-lEIIp {
	padding-bottom: 18px !important;
}

.Uploader-padding4-rRrxc {
	padding-bottom: 24px !important;
}

.Uploader-padding5-sBrEp {
	padding-bottom: 30px !important;
}

.Uploader-padding6-Tp6zI {
	padding-bottom: 36px !important;
}

.Uploader-padding7-qJ9T6 {
	padding-bottom: 42px !important;
}

.Uploader-paddingTop1-pDiMj {
	padding-top: 6px !important;
}

.Uploader-paddingTop2-Olgwh {
	padding-top: 12px !important;
}

.Uploader-paddingTop3-a7IxM {
	padding-top: 18px !important;
}

.Uploader-paddingTop4-aeva7 {
	padding-top: 24px !important;
}

.Uploader-paddingTop5-ZVbgB {
	padding-top: 30px !important;
}

.Uploader-paddingTop6-b_hWi {
	padding-top: 36px !important;
}

.Uploader-paddingTop7-Gl0VJ {
	padding-top: 42px !important;
}

.Uploader-noPadding-xYv8v {
	padding: 0px !important;
}

.Uploader-textBold-FFkgk {
	font-weight: 500 !important;
}

.Uploader-textBolder-yoWKz {
	font-weight: 700 !important;
}

.Uploader-textNormal-pnyKQ {
	font-weight: normal !important;
}

.Uploader-spaceBottom20-fwlD9 {
	margin-bottom: 20px;
}

.Uploader-spaceBottom10-ng2bG {
	margin-bottom: 10px;
}

.Uploader-marginNone-h39Rz {
	margin: 0;
}

.Uploader-spaceBottom15-hjSYU {
	margin-bottom: 15px;
}

.Uploader-marginTopNone-H3bDP {
	margin-top: 0;
}

.Uploader-spaceTop11-CRmlO {
	margin-top: 11px;
}

.Uploader-spaceTop21-rr8oL {
	margin-top: 21px;
}

.Uploader-spaceTop20-ji7vu {
	margin-top: 20px;
}

.Uploader-spaceTop10-iyisA {
	margin-top: 10px;
}

/*New Design Text Colors */

.Uploader-textDarkBlue-Fu80Q {
	color: rgb(20, 39, 94) !important;
}

.Uploader-textLightBlue-NhrqQ {
	color: rgb(57, 87, 106) !important;
}

.Uploader-textLightSandleGreen-D1s8a {
	color: rgb(76, 86, 41) !important;
}

.Uploader-textLightBrown-CS2Vg {
	color: rgb(115, 79, 33) !important;
}

.Uploader-textMediumMaroon-LnOvo {
	color: rgb(87, 37, 51) !important;
}

.Uploader-textBrown-r7gLX {
	color: rgb(160, 47, 24) !important;
}

.Uploader-textMaroon-cuG3n {
	color: rgb(155, 49, 67) !important;
}

.Uploader-textDarkBrown-E6Oj1 {
	color: rgb(83, 18, 16) !important;
}

.Uploader-textMediumBrown-RhRha {
	color: rgb(142, 28, 10) !important;
}

.Uploader-textSkyBlue-CvZz3 {
	color: rgb(37, 117, 141) !important;
}

.Uploader-textGray-wOCwj {
	color: rgb(77, 65, 51) !important;
}

.Uploader-commonHeaderAdmin-u1qgU {
	position: fixed !important;
}

.Uploader-adminLayout-ZAQMv {
	padding-top: 64px !important;
}

.Uploader-box-JxULb h2 {
	font-size: 21px;
	font-weight: 600;
}

.Uploader-exportLink-f8pdd {
	margin-bottom: -29px;
}

.Uploader-blockCenter-DcIq3 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Uploader-panelHeader-pP8Uh {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Uploader-currencyselect-g0im0 {
	width: 100%;
	margin-right: 0px;
}

.Uploader-panelHeader-pP8Uh {
	overflow: hidden;
	position: relative;
}

.Uploader-mar0-_Okxh {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Uploader-blockCenter-DcIq3 {
		padding: 0px;
	}

	.Uploader-panelHeader-pP8Uh {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Uploader-sideAdminPageWrapper-teU74 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Uploader-panelHeader-pP8Uh {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Uploader-table-KVFdU {
	display: table;
}

.Uploader-tableRow-GwUch {
	display: table-row;
}

.Uploader-tableCell-j6s6a {
	display: table-cell;
	float: none;
}

.Uploader-formGroup-phU4A {
	margin-bottom: 6px;
}

.Uploader-select-aWxvS {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Uploader-noMargin-ujLdC {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Uploader-exportLink-f8pdd {
	padding-top: 10px;
	padding-right: 10px;
}

.Uploader-labelTextNew-xMbwV {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Uploader-displayInline-Wfj4X {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Uploader-btnUPdate-x1Hwe {
	display: inline-block;
}

.Uploader-btnModalDelete-dp0L1 {
	display: inline-block;
	margin-left: 15px;
}

.Uploader-radioBtn-tKhV8 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Uploader-backgroundImg-gGOCs {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Uploader-btnUPdate-x1Hwe {
		display: block;
		margin-bottom: 12px;
	}

	.Uploader-btnModalDelete-dp0L1 {
		display: block;
		margin-left: 0px;
	}

	.Uploader-btnWidth-FJW0P {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Uploader-bannerImageBg-KjeFP {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Uploader-bannerDelete-pidZi {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Uploader-modalRoot-atTHt {
	padding: 32px;
}

.Uploader-modalBorderBottom-uJA9r {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Uploader-logInModalBody-X8da7 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Uploader-exportSection-zHN0B {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Uploader-exportSectionGridSub-tysUX {
	grid-template-columns: 50% 49% !important;
}

.Uploader-exportText-e7yST {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Uploader-exportLinkImg-gtuW8 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Uploader-vtrMiddle-Re8mx {
	vertical-align: middle;
}

.Uploader-exportImg-hhbeQ {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Uploader-profileViewlabel-Hcdii {
	display: inline-block;
	width: 38%
}

.Uploader-profileViewMainContent-Mvfud {
	display: inline-block;
	width: 62%;
}

.Uploader-profileViewMain-qiLg2 {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Uploader-profileViewInner-vGw6b {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Uploader-profileImageSection-eJdy5 {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Uploader-lastviewInner-IQwds {
	padding: 10px;
}

.Uploader-whyHostHoriLine-A9YG7 {
	margin: 30px 0;
}

.Uploader-tableGrid-MNv2C {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Uploader-headingContent-Hn2lp {
	font-size: 18px;
	font-weight: 500;
}

.Uploader-refundTextColor-mLg_C {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Uploader-dividerLine-SJjKE {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Uploader-smallContent-lBiP8 {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Uploader-sideAdminPageWrapper-teU74 {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Uploader-sideAdminPageWrapper-teU74 {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Uploader-exportSection-zHN0B {
		grid-template-columns: 100%;
	}

	.Uploader-exportSectionGridSub-tysUX {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Uploader-profileViewlabel-Hcdii {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Uploader-profileViewMainContent-Mvfud {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Uploader-ChangeToUpperCase-aDW6A {
	text-transform: uppercase
}

.Uploader-noBorder-JObzA {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Uploader-siteAdminHeading-j5ndf {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Uploader-siteAdminSubHeading-aGaIX {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Uploader-adminFormDivider-yuMkx {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Uploader-space1-sO2sY`,
	"space2": `Uploader-space2-UKJxq`,
	"space3": `Uploader-space3-Twa5a`,
	"space4": `Uploader-space4-LqZrl`,
	"space5": `Uploader-space5-L02z_`,
	"space6": `Uploader-space6-uhfN7`,
	"space7": `Uploader-space7-ick37`,
	"spaceTop8": `Uploader-spaceTop8-BfqR0`,
	"spaceTop1": `Uploader-spaceTop1-shN8P`,
	"spaceTop2": `Uploader-spaceTop2-dqSi3`,
	"spaceTop3": `Uploader-spaceTop3-CxDeV`,
	"spaceTop4": `Uploader-spaceTop4-grgmC`,
	"spaceTop5": `Uploader-spaceTop5-zbfto`,
	"spaceTop6": `Uploader-spaceTop6-sqgrs`,
	"spaceTop7": `Uploader-spaceTop7-pJ0n_`,
	"noMargin": `Uploader-noMargin-ujLdC`,
	"padding1": `Uploader-padding1-xT8iw`,
	"padding2": `Uploader-padding2-wAK9l`,
	"padding3": `Uploader-padding3-lEIIp`,
	"padding4": `Uploader-padding4-rRrxc`,
	"padding5": `Uploader-padding5-sBrEp`,
	"padding6": `Uploader-padding6-Tp6zI`,
	"padding7": `Uploader-padding7-qJ9T6`,
	"paddingTop1": `Uploader-paddingTop1-pDiMj`,
	"paddingTop2": `Uploader-paddingTop2-Olgwh`,
	"paddingTop3": `Uploader-paddingTop3-a7IxM`,
	"paddingTop4": `Uploader-paddingTop4-aeva7`,
	"paddingTop5": `Uploader-paddingTop5-ZVbgB`,
	"paddingTop6": `Uploader-paddingTop6-b_hWi`,
	"paddingTop7": `Uploader-paddingTop7-Gl0VJ`,
	"noPadding": `Uploader-noPadding-xYv8v`,
	"textBold": `Uploader-textBold-FFkgk`,
	"textBolder": `Uploader-textBolder-yoWKz`,
	"textNormal": `Uploader-textNormal-pnyKQ`,
	"spaceBottom20": `Uploader-spaceBottom20-fwlD9`,
	"spaceBottom10": `Uploader-spaceBottom10-ng2bG`,
	"marginNone": `Uploader-marginNone-h39Rz`,
	"spaceBottom15": `Uploader-spaceBottom15-hjSYU`,
	"marginTopNone": `Uploader-marginTopNone-H3bDP`,
	"spaceTop11": `Uploader-spaceTop11-CRmlO`,
	"spaceTop21": `Uploader-spaceTop21-rr8oL`,
	"spaceTop20": `Uploader-spaceTop20-ji7vu`,
	"spaceTop10": `Uploader-spaceTop10-iyisA`,
	"textDarkBlue": `Uploader-textDarkBlue-Fu80Q`,
	"textLightBlue": `Uploader-textLightBlue-NhrqQ`,
	"textLightSandleGreen": `Uploader-textLightSandleGreen-D1s8a`,
	"textLightBrown": `Uploader-textLightBrown-CS2Vg`,
	"textMediumMaroon": `Uploader-textMediumMaroon-LnOvo`,
	"textBrown": `Uploader-textBrown-r7gLX`,
	"textMaroon": `Uploader-textMaroon-cuG3n`,
	"textDarkBrown": `Uploader-textDarkBrown-E6Oj1`,
	"textMediumBrown": `Uploader-textMediumBrown-RhRha`,
	"textSkyBlue": `Uploader-textSkyBlue-CvZz3`,
	"textGray": `Uploader-textGray-wOCwj`,
	"commonHeaderAdmin": `Uploader-commonHeaderAdmin-u1qgU`,
	"adminLayout": `Uploader-adminLayout-ZAQMv`,
	"box": `Uploader-box-JxULb`,
	"exportLink": `Uploader-exportLink-f8pdd`,
	"blockCenter": `Uploader-blockCenter-DcIq3`,
	"panelHeader": `Uploader-panelHeader-pP8Uh`,
	"currencyselect": `Uploader-currencyselect-g0im0`,
	"mar0": `Uploader-mar0-_Okxh`,
	"sideAdminPageWrapper": `Uploader-sideAdminPageWrapper-teU74`,
	"table": `Uploader-table-KVFdU`,
	"tableRow": `Uploader-tableRow-GwUch`,
	"tableCell": `Uploader-tableCell-j6s6a`,
	"formGroup": `Uploader-formGroup-phU4A`,
	"select": `Uploader-select-aWxvS`,
	"labelTextNew": `Uploader-labelTextNew-xMbwV`,
	"displayInline": `Uploader-displayInline-Wfj4X`,
	"btnUPdate": `Uploader-btnUPdate-x1Hwe`,
	"btnModalDelete": `Uploader-btnModalDelete-dp0L1`,
	"radioBtn": `Uploader-radioBtn-tKhV8`,
	"backgroundImg": `Uploader-backgroundImg-gGOCs`,
	"btnWidth": `Uploader-btnWidth-FJW0P`,
	"bannerImageBg": `Uploader-bannerImageBg-KjeFP`,
	"bannerDelete": `Uploader-bannerDelete-pidZi`,
	"modalRoot": `Uploader-modalRoot-atTHt`,
	"modalBorderBottom": `Uploader-modalBorderBottom-uJA9r`,
	"logInModalBody": `Uploader-logInModalBody-X8da7`,
	"exportSection": `Uploader-exportSection-zHN0B`,
	"exportSectionGridSub": `Uploader-exportSectionGridSub-tysUX`,
	"exportText": `Uploader-exportText-e7yST`,
	"exportLinkImg": `Uploader-exportLinkImg-gtuW8`,
	"vtrMiddle": `Uploader-vtrMiddle-Re8mx`,
	"exportImg": `Uploader-exportImg-hhbeQ`,
	"profileViewlabel": `Uploader-profileViewlabel-Hcdii`,
	"profileViewMainContent": `Uploader-profileViewMainContent-Mvfud`,
	"profileViewMain": `Uploader-profileViewMain-qiLg2`,
	"profileViewInner": `Uploader-profileViewInner-vGw6b`,
	"profileImageSection": `Uploader-profileImageSection-eJdy5`,
	"lastviewInner": `Uploader-lastviewInner-IQwds`,
	"whyHostHoriLine": `Uploader-whyHostHoriLine-A9YG7`,
	"tableGrid": `Uploader-tableGrid-MNv2C`,
	"headingContent": `Uploader-headingContent-Hn2lp`,
	"refundTextColor": `Uploader-refundTextColor-mLg_C`,
	"dividerLine": `Uploader-dividerLine-SJjKE`,
	"smallContent": `Uploader-smallContent-lBiP8`,
	"ChangeToUpperCase": `Uploader-ChangeToUpperCase-aDW6A`,
	"noBorder": `Uploader-noBorder-JObzA`,
	"siteAdminHeading": `Uploader-siteAdminHeading-j5ndf`,
	"siteAdminSubHeading": `Uploader-siteAdminSubHeading-aGaIX`,
	"adminFormDivider": `Uploader-adminFormDivider-yuMkx`
};
module.exports = ___CSS_LOADER_EXPORT___;
